<template>
  <div class="contents">
    <div class="wrap">
      <section>
        <h2 class="page_title --view">포장상품관리</h2>
        <article>
          <ul class="search_filter">
            <li>
              <p>포장상품명</p>
              <input type="text" placeholder="포장상품명을 입력하세요" class="form_control" v-model="searchInfo.wrapperName">
            </li>
            <li>
              <p>포장종류</p>
              <div class="form_select">
                <b-form-select v-model="searchInfo.wrapperClass">
                  <b-form-select-option value="">전체</b-form-select-option>
                  <b-form-select-option v-for="(item, index) in wrapperClassList" :key="index" :value="item.dtl_code">
                    {{ item.dtl_code_nm }}
                  </b-form-select-option>
                </b-form-select>
              </div>
            </li>
            <li>
              <button class="btn btn_md btn_outline" @click="fn_search">조회</button>
            </li>
          </ul>
        </article>
      </section>
      <section class="view">
        <div class="table_list">
          <div class="table_option">
            <div class="form_select"></div>
            <button class="btn btn_md btn_darkblue" @click="fn_move_reg_page">신규 등록</button>
          </div>
          <table class="list no_view">
            <thead>
            <tr>
              <th>이미지</th>
              <th>포장상품명</th>
              <th>포장종류</th>
              <th>기준재고수량</th>
              <th>판매단가</th>
              <th>관리</th>
            </tr>
            </thead>
            <tbody>
            <tr v-if="wrapperList.length == 0">
              <td colspan="6"><span>데이터가 없습니다.</span></td>
            </tr>
            <tr v-for="(item, index) in wrapperList" :key="index">
              <td>
                    <span class="img_area">
                      <img :src="'/file/getImgFile/' + item.wrapper_file_id" alt="">
                    </span>
              </td>
              <td class="al"><span>{{ item.wrapper_nm }}</span></td>
              <td><span>{{ item.wrapper_class_nm }}</span></td>
                <td><span>{{ item.wrapper_stdr_invt_qy }}</span></td>
              <td><span>{{ item.wrapper_sale_prc }}</span></td>
              <td>
                <div class="form_inline">
                  <button class="icon icon_del" @click="fn_delete(item.wrapper_cd,item.wrapper_file_id)"></button>
                  <button class="icon icon_edit" @click="fn_move_dtl_page(item.wrapper_cd)"></button>
                </div>
              </td>
            </tr>
            </tbody>
          </table>
          <Pagination :pageInfo="searchInfo.pageInfo" v-show="pagingShow"/>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import commonUtil from "@/mixin/commonUtil";
import Pagination from "@/components/AdminPagination.vue"

export default {
  name: 'WrapperMngt',
  components: {
    Pagination,
  },
  mixins: [commonUtil],
  data() {
    return {
      searchInfo: {
        wrapperName: '',
        wrapperClass: '',
        pageInfo: {
          page: 1,
          pageSize: 10,
          totPage: 0
        }
      },
      pagingShow: false,
      wrapperClassList: [],
      wrapperList: [],
      selected: null
    }
  },
  async created() {
    //공통코드 - 포장종류
    this.wrapperClassList = await this.getCode('GC00000005');
    console.log("@@@@ noticeStatusList : %o", this.noticeStatusList);
    this.fn_search();
  },
  methods: {
    fn_move_reg_page() {
      this.$store.dispatch('wrapper/setWrapperCd', '');
      this.$store.dispatch('wrapper/setStatus', '');
      this.$router.push("/admin/wrapper/WrapperMngtReg");
    },
    fn_search() {
      console.log("@@@ search");
      axios
          .post("/api/admin/wrapper/searchWrapper", this.searchInfo)
          .then((res) => {
            console.log("@@@@ res : %o", res);
            this.wrapperList = res.data.wrapperInfo;

            console.log("@@@@ wrapperList : %o", this.wrapperList);

            this.searchInfo.pageInfo.totPage = res.data.totCnt;

            if (this.searchInfo.pageInfo.totPage > 0) {
              this.pagingShow = true;
            }

          })
          .catch((err) => console.log(err));
    },
    fn_move_dtl_page(wrapperCd) {
      this.$store.dispatch('wrapper/setWrapperCd', wrapperCd);
      this.$store.dispatch('wrapper/setStatus', 'M');
      this.$router.push("/admin/wrapper/WrapperMngtReg");
    },
    fn_delete(wrapperCd, wrapperFileId) {

      let param = new Object();
      param.wrapperCd = wrapperCd;
      param.fileId = wrapperFileId;

      axios
          .post("/api/admin/wrapper/deleteWrapper", param)
          .then((res) => {
            alert("삭제되었습니다");
            this.fn_search();
          })
          .catch((err) => console.log(err));
    }


  }
}
</script>